import { render } from "./GroupsDisplay.vue?vue&type=template&id=13907793&scoped=true"
import script from "./GroupsDisplay.vue?vue&type=script&lang=js"
export * from "./GroupsDisplay.vue?vue&type=script&lang=js"

import "./GroupsDisplay.vue?vue&type=style&index=0&id=13907793&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13907793"]])

export default __exports__